// ChoralMusicalPanel.jsx
import React from "react";

function displayList(items) {
  const arr = Array.isArray(items) ? items : [];
  if (arr.length === 0) {
    return <span className="ce-field__value--unknown">Not yet verified</span>;
  }
  return arr.join(", ");
}

function displayDifficulty(diff) {
  if (!diff) return <span className="ce-field__value--unknown">Not yet verified</span>;
  const parts = [];
  if (diff.choir && diff.choir !== "unknown")    parts.push(`Choir: ${diff.choir}`);
  if (diff.organ && diff.organ !== "unknown")    parts.push(`Organ: ${diff.organ}`);
  if (diff.assembly && diff.assembly !== "unknown") parts.push(`Assembly: ${diff.assembly}`);
  if (!parts.length) return <span className="ce-field__value--unknown">Not yet verified</span>;
  return parts.join(" · ");
}

export default function ChoralMusicalPanel({ work }) {
  return (
    <section className="ce-panel" data-testid="ce-musical-panel">
      <h3 className="ce-panel__heading">Musical Resources</h3>
      <div className="ce-field">
        <div className="ce-field__label">Voicing</div>
        <div className="ce-field__value">{displayList(work.voicing)}</div>
      </div>
      <div className="ce-field">
        <div className="ce-field__label">Accompaniment</div>
        <div className="ce-field__value">{displayList(work.accompaniment)}</div>
      </div>
      <div className="ce-field">
        <div className="ce-field__label">Difficulty</div>
        <div className="ce-field__value">{displayDifficulty(work.difficulty)}</div>
      </div>
      <div className="ce-field">
        <div className="ce-field__label">Duration</div>
        <div className="ce-field__value">
          {work.duration_minutes
            ? `${work.duration_minutes} min`
            : <span className="ce-field__value--unknown">Not yet verified</span>}
        </div>
      </div>
    </section>
  );
}
